import React from 'react';
import { useParams } from 'react-router';

import { HistoriesPanel } from '@admin/components/histories/panel';
import { OpsAuditResultsPanel } from '@admin/components/ops_audit/audit_results/audit_results_panel';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { History__Subject } from '@admin/schema';
import { useLogisticsDetailedSkuQuery } from '@admin/schema';

import { LogisticsSkuBasicInfoPanel } from './basic_info_panel';
import { ImagesPanel } from './images_panel';

export const LogisticsDetailedSku: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useLogisticsDetailedSkuQuery({ client, variables: { id } });
  useTitle(data ? `Sku: #${data.logisticsSku.value}` : 'Detailed SKU');

  if (loading || !data) {
    return <Spinner />;
  }
  const sku = data.logisticsSku;
  const images =
    data.logisticsSku.measuredWeightImage == null
      ? data.logisticsSku.verificationImages
      : data.logisticsSku.verificationImages.concat(data.logisticsSku.measuredWeightImage);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <LogisticsSkuBasicInfoPanel sku={sku} />
        </div>
      </div>
      <ImagesPanel images={images} />
      <HistoriesPanel type={History__Subject.LogisticsSku} id={id} />
      <OpsAuditResultsPanel resourceType={'Logistics::Sku'} resourceID={id} />
    </>
  );
};
